import React from 'react';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';

const FooterNavigation = () => {
  return (
    <div style={{ paddingBottom: "16px" }}>
      <div style={{ display: "flex", justifyContent: "center", gap: "30px", flexWrap: "wrap", fontWeight: 'bold', fontsize: '0.875rem' }}>

        <Button

          sx={{
            color: "#F27920",
            fontWeight: "bold",
            // minWidth: '150px',
            // padding: "10px 16px",
            fontSize: "0.875rem", // Standardized text size
          }}
        >
          <Link href="/WeSupport" color="#F27920" underline="none" style={{ cursor: "pointer", "&:hover": { color: "#F27920" } }}>
            WHO WE SUPPORT
          </Link>
        </Button>

        <Button

          sx={{
            color: "#F27920",
            fontWeight: "bold",
            // minWidth: '150px',
            // padding: "10px 16px",
            fontSize: "0.875rem", // Standardized text size
          }}
        >
          <Link href="/FoundationNews" color="#F27920" underline="none" style={{ cursor: "pointer", fontSize: '0.875rem', "&:hover": { color: "#F27920" } }}>
            FOUNDATION NEWS
          </Link>
        </Button>

        <Button

          sx={{
            color: "#F27920",
            fontWeight: "bold",
            // minWidth: '150px',
            // padding: "10px 16px",
            fontSize: "0.875rem", // Standardized text size
          }}
        >
          <Link href="/SeaTurtleFacts" color="#F27920" underline="none" style={{ cursor: "pointer", fontSize: '0.875rem', "&:hover": { color: "#F27920" } }}>
            SEA TURTLE FACTS
          </Link>
        </Button>

        <Button

          sx={{
            color: "#F27920",
            fontWeight: "bold",
            // minWidth: '150px',
            // padding: "10px 16px",
            fontSize: "0.875rem", // Standardized text size
          }}
        >
          <Link href="/Forms/CashDonation.html" color="#F27920" underline="none" style={{ cursor: "pointer", fontSize: '0.875rem', "&:hover": { color: "#F27920" } }}>
            Donate and Become a Member Today!
          </Link>
        </Button>


        <Button

          sx={{
            color: "#F27920",
            fontWeight: "bold",
            // minWidth: '150px',
            // padding: "10px 16px",
            fontSize: "0.875rem", // Standardized text size
          }}
        >
          <Link href="/Forms/CorporateMembership.html" color="#F27920" underline="none" style={{ cursor: "pointer", fontSize: '0.875rem', "&:hover": { color: "#F27920" } }}>
            Become a corporate partner
          </Link>
        </Button>


      </div>
    </div >
  );
};

export default FooterNavigation;
